import { getStoreId } from "$/hooks/use-store-information"
import {
  damperBrandQueries,
  damperServiceActionNameQueries,
  damperServicePriceQueries,
} from "$/lib/queries/damper-service-queries"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/damper-service")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    queryClient.prefetchQuery(damperBrandQueries.list())
    if (storeId) {
      queryClient.prefetchQuery(damperServicePriceQueries.list({ storeId }))
      queryClient.prefetchQuery(
        damperServiceActionNameQueries.list({ storeId }),
      )
      queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
    }
    return {
      crumbs: "alfred.settings.nav.damperService.label",
    }
  },
})
